import { useWalletsMe } from '@/api/wallets';
import { MultiExchangeRateSnapshot } from '@/models/multi-exchange-rate-snapshots';
import { Decimal } from '@starsoft/common/services/Decimal';
import { useCallback } from 'react';

export function useMultiExchangeRatio() {
  const { wallet } = useWalletsMe();
  const currentCoin = wallet?.currentAccount?.coin;

  const getConvertedExchangeRatio = useCallback(
    (exchange: MultiExchangeRateSnapshot) => {
      if (!currentCoin || !exchange.convertedAmounts) {
        return new Decimal(0, { scale: 2 });
      }

      const amount = exchange.convertedAmounts[currentCoin.code];

      return amount;
    },
    [currentCoin],
  );

  return {
    getConvertedExchangeRatio,
    currentCoin,
  };
}
